import { VALIDATIONS_SET_DATA } from '../actions';

export const setValidationsData = (data) => {
    return { type: VALIDATIONS_SET_DATA, payload: data };
};
